import React, { useState } from "react";

const SquareFlatBtnsUpload = ({
  name,
  onClick,
  Icon,
  title,
  className = "",
  SqaureBtnbackgroundColor = "#1c1c1c",
  border = "0.2px solid #c79f27",
  extraStyles = {},
  iconWidth,
  iconHeight,
  buttonWidth,
  buttonHeight,
  borderRadius = "4px",
  titleStyle = {},
}) => {
  const [pressed, setPressed] = useState(false);

  const handleClick = () => {
    setPressed(true);
    onClick();
    setTimeout(() => setPressed(false), 500);
  };

  const buttonStyles = {
    backgroundColor: SqaureBtnbackgroundColor,
    border,
    width: buttonWidth,
    height: buttonHeight,
    cursor: "pointer",
    boxShadow: pressed
      ? "inset 0 0 10px 0px rgba(0,0,0,0.5)"
      : "0 0 10px 0px rgba(0, 0, 0, 0.5)",
    transition: "background-color 1s cubic-bezier(0.075, 0.82, 0.165, 1)",
    ...(borderRadius && { borderRadius }),
    ...extraStyles,
  };

  return (
    <div
      name={name}
      className={`upload-remote-category-choice-btn ${className} ${pressed ? "pressed-btn-effect" : ""}`}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onClick={handleClick}
      style={buttonStyles}
    >
      {Icon && <Icon width={iconWidth} height={iconHeight} />}
      <p style={titleStyle}>{title}</p>
    </div>
  );
};

export default SquareFlatBtnsUpload;
